import { render, staticRenderFns } from "./living-payment.vue?vue&type=template&id=781f9ffb&scoped=true&"
import script from "./living-payment.vue?vue&type=script&lang=js&"
export * from "./living-payment.vue?vue&type=script&lang=js&"
import style0 from "./living-payment.vue?vue&type=style&index=0&id=781f9ffb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781f9ffb",
  null
  
)

export default component.exports